// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border[data-v-06164062]{border:.052083rem solid #000;width:100%;padding:1.041667rem}.Application[data-v-06164062]{justify-content:right;margin-bottom:.260417rem}.flex[data-v-06164062]{display:flex;align-items:center}.icons[data-v-06164062]{cursor:pointer}.inputOn[data-v-06164062]{justify-content:center}[data-v-06164062] .el-input__inner{width:15.625rem;margin-left:.520833rem}", ""]);
// Exports
module.exports = exports;
